import React from 'react'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import GoogleIcon from '../../../icon/GoogleIcon'
import { getEffectivenessReportTab } from '../../../components/constants/effectivenessReportTabs'

const EMPTY_TITLE = 'No hay actividades'
const EMPTY_DESCRIPTION = 'Cuando existan registros en el rango seleccionado, aparecerán aquí con su detalle.'

export default function EffectivenessReportEmptyState({ tabValue }) {
  const tab = getEffectivenessReportTab(tabValue)
  const icon = tab?.icon ? (
    <GoogleIcon
      name={tab.icon}
      size={tab.iconSize ?? 22}
      filled={Boolean(tab.filled)}
      color="#597FA9"
    />
  ) : null

  return (
    <MobileEmptyStateCard
      icon={icon}
      title={EMPTY_TITLE}
      description={EMPTY_DESCRIPTION}
    />
  )
}
